import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, Link, useNavigate, useLocation } from 'react-router-dom';
import { ChevronRight, RefreshCw } from 'lucide-react';
import ProjectSidebar from './ProjectSidebar.tsx';
import StatusFacturas from '../views/EstatusFacturas.tsx';
import BuscarProveedores from '../Proyectos/BuscarProveedores.tsx';
import BuscarFacturas from '../Proyectos/BuscarFacturas.tsx';
import ValidacionSUNAT from '../views/ValidacionSUNAT.tsx';
import FlowExtensionAPI from '../views/FlowExtensionAPI.tsx';
import Configuracioncafo from '../views/configuracionCAFO.tsx';
import CompararXML from '../views/compararXML.tsx';
import ValidadorEstructura from '../views/ValidadorEstructura.tsx';
import PruebasApisProyecto from '../APIs/PruebasApisProyecto.tsx';
import GeneralConfig from '../views/AribaCommerce/Integracion/configuracionGeneral.tsx';
import { esErpCloud } from '../views/AribaCommerce/Integracion/useGeneralConfig.ts';
import OrdenCompraConfig from '../views/AribaCommerce/Integracion/ordenCompra.tsx';
import CutoverConfig from '../views/AribaCommerce/Integracion/cutover.tsx';
import AvisoExpedicionConfig from '../views/AribaCommerce/Integracion/avisoExpedicion.tsx';
import ConfirmacionConfig from '../views/AribaCommerce/Integracion/confirmacion.tsx';
import RecepcionConfig from '../views/AribaCommerce/Integracion/recepcion.tsx';
import HesConfig from '../views/AribaCommerce/Integracion/hesAriba.tsx';
import HesErpConfig from '../views/AribaCommerce/Integracion/hesErp.tsx';
import FacturasConfig from '../views/AribaCommerce/Integracion/facturas.tsx';
import EstatusFacturasConfig from '../views/AribaCommerce/Integracion/estatusFacturas.tsx';
import CommerceHome, { FLOW_EXTENSION_API_HABILITADO } from '../Ariba/CommerceHome.tsx';
import Miembros from '../Proyectos/Miembros.tsx';
import EditarProyecto from '../Proyectos/EditarProyecto.tsx';
import DetalleProyecto from '../Proyectos/DetalleProyecto.tsx';
import IncidentesSection from '../Proyectos/components/IncidentesSection.tsx';
import MesaAyudaSection from '../Proyectos/components/MesaAyudaSection.tsx';
import TareasSection from '../Proyectos/components/TareasSection.tsx';
import HitosSection from '../Proyectos/components/HitosSection.tsx';
import CambiosSection from '../Proyectos/components/CambiosSection.tsx';
import VersionesSection from '../Proyectos/components/VersionesSection.tsx';
import AprendizajeSection from '../Proyectos/components/AprendizajeSection.tsx';
import CasosPruebaSection from '../Proyectos/components/CasosPruebaSection.tsx';
import EspecificacionesTecnicasSection from '../Proyectos/components/EspecificacionesTecnicasSection.tsx';
import AusenciasEquipo from '../Proyectos/AusenciasEquipo.tsx';
import HorasSection from '../Proyectos/components/HorasSection.tsx';
import ResumenHorasCliente from '../Proyectos/components/ResumenHorasCliente.tsx';
import ProjectSolutionsHome from '../Proyectos/ProjectSolutionsHome.tsx';
import HerramientasHome from '../Proyectos/HerramientasHome.tsx';
import SolucionGate from '../Proyectos/components/SolucionGate.tsx';
import ModuloGate from '../Proyectos/components/ModuloGate.tsx';
import ProyectoGeneralHome from '../Proyectos/ProyectoGeneralHome.tsx';
import { esProyectoSap, etiquetaDocumentacion } from '../Proyectos/modulosConfig.ts';
import SolucionPlaceholder from '../Proyectos/components/SolucionPlaceholder.tsx';
import CanalIntegracionView from '../Proyectos/components/integracion/CanalIntegracionView.tsx';
import BadiCatalogo from '../Proyectos/BadiCatalogo.tsx';
import TransaccionesCatalogo from '../Proyectos/TransaccionesCatalogo.tsx';
import InterfacesCatalogo from '../Proyectos/InterfacesCatalogo.tsx';
import ProgramasCatalogo from '../Proyectos/ProgramasCatalogo.tsx';
import TablasCatalogo from '../Proyectos/TablasCatalogo.tsx';
import OrganigramaProyecto from '../Proyectos/OrganigramaProyecto.tsx';
import MiEspacioProyecto from '../Proyectos/MiEspacioProyecto.tsx';
import CredentialsPanel from '../../components/credenciales/CredentialsPanel.tsx';
import RepositorioComunicacion from '../Proyectos/components/RepositorioComunicacion.tsx';
import { OTRAS_SOLUCIONES } from '../Proyectos/solucionesConfig.ts';
import { CANALES_INTEGRACION } from '../Proyectos/integrationChannels.ts';
import { useProject } from '../../context/ProjectContext.tsx';
import { getCliente } from '../../services/clienteService.ts';
import ProjectOrgBanner from './ProjectOrgBanner.tsx';
import styles from '../../styles/DashboardCA.module.css';

const SECTION_TITLES: Record<string, string> = {
  '': 'Soluciones del Proyecto',
  hitos: 'Hitos y avance',
  cambios: 'Solicitudes de cambio',
  versiones: 'Versiones',
  aprendizaje: 'Aprendizaje',
  commerce: 'Commerce Automation',
  status: 'Estatus de Facturación',
  validacion: 'Validación SUNAT',
  flow: 'Flow Extension API',
  config: 'Configuración de Sistema',
  compXML: 'Comparar XML',
  pruebas: 'Casos de Prueba',
  especificaciones: 'Especificaciones Técnicas',
  herramientas: 'Herramientas',
  'validador-estructura': 'Validador de Estructura',
  'apis-test': 'Pruebas APIs',
  badis: 'BAdIs y Objetos ABAP',
  transacciones: 'Transacciones SAP',
  interfaces: 'Interfaces / Canales',
  programas: 'Catálogo de Programas',
  tablas: 'Catálogo de Tablas',
  credenciales: 'Credenciales del Proyecto',
  'repositorio-comunicacion': 'Repositorio de Comunicación',
  'mi-espacio': 'Mi Espacio',
  'integracion/generales': 'Configuraciones Generales del Add-on (ERP)',
  'integracion/oc': 'Integración: Orden de Compra',
  'integracion/expedicion': 'Integración: Aviso de Expedición',
  'integracion/confirmacion': 'Integración: Confirmación',
  'integracion/recepcion': 'Integración: Recepción de Mercancía',
  'integracion/hes-ariba': 'Integración: HES (SAP Ariba)',
  'integracion/hes-erp': 'Integración: HES (ERP)',
  'integracion/facturas': 'Integración: Facturas',
  'integracion/estatus-facturas': 'Integración: Estatus de Facturas',
  'integracion/cutover': 'Plan de Cutover (Salida a Producción)',
  miembros: 'Miembros del Proyecto',
  organigrama: 'Organigrama del Proyecto',
  ausencias: 'Ausencias del Equipo',
  editar: 'Editar Proyecto',
  detalle: 'Detalle del Proyecto',
  incidentes: 'Seguimiento de Incidentes',
  'mesa-ayuda': 'Mesa de ayuda',
  tareas: 'Tareas del Proyecto',
  horas: 'Mis Horas',
  ...Object.fromEntries(OTRAS_SOLUCIONES.map(s => [s.path, s.label])),
  ...Object.fromEntries(CANALES_INTEGRACION.map(c => [`integracion/${c.solucion}/${c.slug}`, c.label]))
};

export default function ProjectShell() {
  const { project, projectId, loading, esCliente } = useProject();
  const navigate = useNavigate();
  const location = useLocation();
  const [clienteNombre, setClienteNombre] = useState<string | null>(null);

  useEffect(() => {
    // Sub-fase G2: preferir el nombre desnormalizado en el proyecto — un
    // "guest" (miembro directo de este proyecto, pero no de su org) ya no
    // puede leer clientes/{clienteId} si pertenece a otra org.
    // getCliente() queda solo como fallback para proyectos legado sin
    // clienteNombre (ver scripts/backfill-cliente-nombre-projects.mjs).
    if (project?.clienteNombre) { setClienteNombre(project.clienteNombre); return; }
    if (!project?.clienteId) { setClienteNombre(null); return; }
    getCliente(project.clienteId)
      .then((cliente) => setClienteNombre(cliente?.name || null))
      .catch((err) => console.error('Error cargando cliente:', err));
  }, [project?.clienteId, project?.clienteNombre]);

  // Sección activa = lo que sigue después de /proyecto/:projectId/
  const basePath = `/proyecto/${projectId}`;
  const activeSection = location.pathname.startsWith(basePath)
    ? location.pathname.slice(basePath.length).replace(/^\//, '')
    : '';

  const isLanding = activeSection === '';

  // Sub-fase K8: en Cloud no existe la versión "Add-on" (concepto
  // on-premise) — el título de esa pantalla deja de mencionarlo.
  const tituloIntegracionGenerales = esErpCloud(project?.erpTipo)
    ? 'Configuraciones Generales'
    : 'Configuraciones Generales del Add-on (ERP)';

  if (loading) {
    return (
      <div className="min-h-screen bg-[rgb(var(--c-bg))] text-gray-400 flex flex-col items-center justify-center gap-3">
        <RefreshCw className="w-8 h-8 animate-spin text-blue-500" />
        <p className="text-sm">Cargando proyecto...</p>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="min-h-screen bg-[rgb(var(--c-bg))] text-gray-400 flex flex-col items-center justify-center gap-3">
        <p className="text-sm">No se encontró el proyecto o no tienes acceso.</p>
        <Link to="/proyectos" className="text-blue-400 hover:underline text-sm">Volver a Mis Proyectos</Link>
      </div>
    );
  }

  const go = (path: string) => navigate(path === '' ? basePath : `${basePath}/${path}`);

  return (
    <div className={styles.dashboardWrapper}>
      {/* Luces decorativas */}
      <div className={`${styles.blob} top-0 right-0 w-[500px] h-[500px] bg-blue-500`} />
      <div className={`${styles.blob} bottom-0 left-0 w-[300px] h-[300px] bg-purple-500`} />

      {/* 🔥 SIDEBAR DE 2 NIVELES (ver ProjectSidebar.tsx / menuConfig.tsx) */}
      <ProjectSidebar
        project={project}
        activeSection={activeSection}
        esCliente={esCliente}
        onNavigate={go}
      />

      {/* CONTENIDO PRINCIPAL */}
      <main className={`flex-1 p-10 relative z-10 overflow-y-auto transition-all duration-500 ${isLanding ? 'max-w-6xl mx-auto' : ''}`}>

        <nav className="flex items-center gap-2 text-sm text-gray-400 mb-4" aria-label="Breadcrumb">
          <Link to="/proyectos" className="hover:text-white transition-colors">Mis Proyectos</Link>
          <ChevronRight size={14} className="opacity-50" />
          {isLanding ? (
            <span className="text-blue-400 font-medium">
              {project.nombre}{clienteNombre ? ` (${clienteNombre})` : ''}
            </span>
          ) : (
            <Link to={basePath} className="text-blue-400 font-medium hover:underline">
              {project.nombre}{clienteNombre ? ` (${clienteNombre})` : ''}
            </Link>
          )}
        </nav>

        <ProjectOrgBanner project={project} />

        <header className="mb-10">
          <h1 className="text-4xl font-light tracking-tight text-white mb-2">
            {activeSection === 'integracion/generales'
              ? tituloIntegracionGenerales
              // Sin SAP Ariba la portada lleva el nombre del proyecto y Especificaciones se llama Documentación.
              : activeSection === '' && !esProyectoSap(project)
                ? project.nombre
                : activeSection === 'especificaciones'
                  ? etiquetaDocumentacion(project)
                  : (SECTION_TITLES[activeSection] || project.nombre)}
          </h1>
          {isLanding && clienteNombre && (
            <p className="text-sm text-gray-400 mb-2">Cliente: {clienteNombre}</p>
          )}
          <div className="h-1 w-20 bg-blue-500 rounded-full" />
        </header>

        <section className={`${isLanding ? '' : 'glass-content-area rounded-3xl p-1'}`}>
          <Routes>
            {/* Portada: SAP Ariba entra a sus soluciones; un proyecto general, a Gestión del proyecto. */}
            <Route index element={esProyectoSap(project) ? <ProjectSolutionsHome /> : <ProyectoGeneralHome />} />
            <Route path="herramientas" element={<HerramientasHome />} />
            <Route path="commerce" element={<ModuloGate modulo="sap-ariba"><SolucionGate solucion="commerce" label="Commerce Automation"><CommerceHome onSelect={(opt) => go(OPTION_TO_PATH[opt] ?? opt)} /></SolucionGate></ModuloGate>} />
            <Route path="status" element={<ModuloGate modulo="sap-ariba"><SolucionGate solucion="commerce" label="Commerce Automation"><StatusFacturas /></SolucionGate></ModuloGate>} />
            <Route path="validacion" element={<ModuloGate modulo="sap-ariba"><SolucionGate solucion="commerce" label="Commerce Automation"><ValidacionSUNAT /></SolucionGate></ModuloGate>} />
            <Route path="facturas" element={<ModuloGate modulo="sap-ariba"><SolucionGate solucion="commerce" label="Commerce Automation"><BuscarFacturas /></SolucionGate></ModuloGate>} />
            <Route path="flow" element={<ModuloGate modulo="sap-ariba">{FLOW_EXTENSION_API_HABILITADO ? <FlowExtensionAPI /> : <Navigate to={basePath} replace />}</ModuloGate>} />
            <Route path="config" element={<ModuloGate modulo="sap-ariba">{esCliente ? <Navigate to={basePath} replace /> : <Configuracioncafo />}</ModuloGate>} />
            <Route path="compXML" element={<ModuloGate modulo="sap-ariba"><CompararXML /></ModuloGate>} />
            <Route path="pruebas" element={<CasosPruebaSection />} />
            <Route path="especificaciones" element={<EspecificacionesTecnicasSection />} />
            <Route path="proveedores" element={<ModuloGate modulo="sap-ariba"><SolucionGate solucion="slp" label="SLP"><BuscarProveedores /></SolucionGate></ModuloGate>} />
            <Route path="validador-estructura" element={<ModuloGate modulo="sap-ariba"><ValidadorEstructura projectId={projectId} projectNombre={project.nombre} /></ModuloGate>} />
            <Route path="apis-test" element={<ModuloGate modulo="sap-ariba"><PruebasApisProyecto clienteId={project.clienteId} clienteNombre={clienteNombre || undefined} projectId={projectId} /></ModuloGate>} />
            <Route path="badis" element={<ModuloGate modulo="sap-ariba"><BadiCatalogo /></ModuloGate>} />
            <Route path="transacciones" element={<ModuloGate modulo="sap-ariba"><TransaccionesCatalogo /></ModuloGate>} />
            <Route path="interfaces" element={<ModuloGate modulo="sap-ariba"><InterfacesCatalogo /></ModuloGate>} />
            <Route path="programas" element={<ModuloGate modulo="sap-ariba"><ProgramasCatalogo /></ModuloGate>} />
            <Route path="tablas" element={<ModuloGate modulo="sap-ariba"><TablasCatalogo /></ModuloGate>} />
            <Route path="credenciales" element={esCliente ? <Navigate to={basePath} replace /> : <CredentialsPanel projectId={projectId} />} />
            <Route path="repositorio-comunicacion" element={<ModuloGate modulo="sap-ariba">{esCliente ? <Navigate to={basePath} replace /> : <RepositorioComunicacion projectId={projectId} />}</ModuloGate>} />
            <Route path="mi-espacio" element={<MiEspacioProyecto />} />

            <Route path="integracion/generales" element={<ModuloGate modulo="sap-ariba"><GeneralConfig /></ModuloGate>} />
            <Route path="integracion/oc" element={<ModuloGate modulo="sap-ariba"><OrdenCompraConfig /></ModuloGate>} />
            <Route path="integracion/expedicion" element={<ModuloGate modulo="sap-ariba"><AvisoExpedicionConfig /></ModuloGate>} />
            <Route path="integracion/confirmacion" element={<ModuloGate modulo="sap-ariba"><ConfirmacionConfig /></ModuloGate>} />
            <Route path="integracion/recepcion" element={<ModuloGate modulo="sap-ariba"><RecepcionConfig /></ModuloGate>} />
            <Route path="integracion/hes-ariba" element={<ModuloGate modulo="sap-ariba"><HesConfig /></ModuloGate>} />
            <Route path="integracion/hes-erp" element={<ModuloGate modulo="sap-ariba"><HesErpConfig /></ModuloGate>} />
            <Route path="integracion/facturas" element={<ModuloGate modulo="sap-ariba"><FacturasConfig /></ModuloGate>} />
            <Route path="integracion/estatus-facturas" element={<ModuloGate modulo="sap-ariba"><EstatusFacturasConfig /></ModuloGate>} />
            <Route path="integracion/cutover" element={<ModuloGate modulo="sap-ariba"><CutoverConfig /></ModuloGate>} />

            {/* Canales de Integración de las demás soluciones (SLP, Sourcing,
                Contracts, ...) — mismo patrón de checklist que Commerce, pero
                genérico (ver integrationChannels.ts / CanalIntegracionView.tsx).
                Gateados por SolucionGate igual que la vista principal de la
                solución: no se puede entrar a un canal de una solución que no
                está activa en este proyecto. */}
            {CANALES_INTEGRACION.map((canal) => (
              <Route
                key={`${canal.solucion}/${canal.slug}`}
                path={`integracion/${canal.solucion}/${canal.slug}`}
                element={
                  <ModuloGate modulo="sap-ariba">
                    <SolucionGate solucion={canal.solucion} label={canal.label}>
                      <CanalIntegracionView canal={canal} />
                    </SolucionGate>
                  </ModuloGate>
                }
              />
            ))}

            <Route path="miembros" element={<Miembros />} />
            <Route path="organigrama" element={<OrganigramaProyecto />} />
            <Route path="ausencias" element={<AusenciasEquipo />} />
            <Route path="editar" element={esCliente ? <Navigate to={basePath} replace /> : <EditarProyecto />} />
            <Route path="detalle" element={<DetalleProyecto />} />
            <Route path="incidentes" element={<IncidentesSection />} />
            <Route path="mesa-ayuda" element={<MesaAyudaSection />} />
            <Route path="tareas" element={<TareasSection />} />
            <Route path="hitos" element={<HitosSection />} />
            <Route path="cambios" element={<CambiosSection />} />
            <Route path="versiones" element={<VersionesSection />} />
            <Route path="aprendizaje" element={<AprendizajeSection />} />
            <Route path="horas" element={esCliente ? <ResumenHorasCliente /> : <HorasSection />} />

            {OTRAS_SOLUCIONES.map(s => (
              <Route
                key={s.slug}
                path={s.path}
                element={
                  <ModuloGate modulo="sap-ariba">
                    <SolucionGate solucion={s.slug} label={s.label}>
                      <SolucionPlaceholder {...s} />
                    </SolucionGate>
                  </ModuloGate>
                }
              />
            ))}

            <Route path="*" element={<Navigate to={basePath} replace />} />
          </Routes>
        </section>
      </main>
    </div>
  );
}

// CommerceHome fue diseñado con claves cortas (integ-oc, integ-expedicion, ...);
// las traducimos a las rutas reales anidadas bajo el proyecto.
const OPTION_TO_PATH: Record<string, string> = {
  'integ-oc': 'integracion/oc',
  'integ-expedicion': 'integracion/expedicion',
  'integ-confirmacion': 'integracion/confirmacion',
  'integ-recepcion': 'integracion/recepcion',
  'integ-hes-ariba': 'integracion/hes-ariba',
  'integ-hes-erp': 'integracion/hes-erp',
  'integ-facturas': 'integracion/facturas',
  'integ-estatus-facturas': 'integracion/estatus-facturas',
  'integ-cutover': 'integracion/cutover'
};
